import React from 'react';
// import AppBar from "../../../Components/header/index";
// import AppProvider from "../../../Components/bootstrap"
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Card';
import { makeStyles } from "@material-ui/core/styles";
import { BooleanInput } from "react-admin"
import Button from '@material-ui/core/Button';
// import Divider from '@material-ui/core/Divider';
// import Profile from "../../../images/profile.png"
// import Switch from '@material-ui/core/Switch';
// import Chip from '../../ScheduleAppointment/Components/chipInput'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelectAttendees } from "./../hooks"
// import { useAttendees } from "./../hooks"
const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: "#F7F7F7",
    }
  },
  Avatar: {
    height: "35px"
  }
}));




function Asynchronous({ form }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const attendeesData = useSelectAttendees()
  console.log("attendeesData", attendeesData)
  // React.useEffect(() => {
  //   let active = true;

  //   if (!loading) {
  //     return undefined;
  //   }

  //   (async () => {
  //     const response = await fetch('https://country.register.gov.uk/records.json?page-size=5000');
  //     const countries = await response.json();
  //     if (active) {
  //       setOptions(Object.keys(countries).map((key) => countries[key].item[0]));
  //     }
  //   })();

  //   return () => {
  //     active = false;
  //   };
  // }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      multiple
      id="asynchronous-demo"
      name="attendees"
      style={{ width: "100%" }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      onChange={(e,v,_reason)=>form.change('selectedAttendees',v)}
      getOptionSelected={(option, value) => option.username === value.username}
      getOptionLabel={(option) => option.username}
      options={attendeesData.loaded ? attendeesData.data : []}
      loading={attendeesData.loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Asynchronous"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}

export default function Schedule({ handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  form,
  props,
  ...rest }) {
  const classes = useStyles();
  // const attendees = useAttendees({ isSingle: values.manyAttendees })

  // const [state, setState] = React.useState({
  //   checkedA: true,
  //   checkedB: true,
  // });

  // const handleChange = (event) => {
  //   setState({ ...state, [event.target.name]: event.target.checked });
  // };
  return (
    <div className={classes.div}>
      <form onSubmit={handleSubmit} noValidate>
        <div style={{ paddingLeft: "4%", paddingRight: "4%", }}>
          <Paper style={{ marginTop: "0px", padding: "15px", boxShadow: "none", }}>
            <Typography variant="subtitle2" style={{ marginTop: "15px", textAlign: "left", fontSize: "24px", marginLeft: "25%" }}>Number of Mentees</Typography>

            <Grid container style={{ marginTop: "1%",zoom:"96%" }} >
              <Grid item sm={3} xs={3}></Grid>
              <Grid item sm={1} xs={3}>
                <Typography varint="body2" style={{ textAlign: "left", marginTop: "5px", marginLeft: "0%" }}>Only Me</Typography>
              </Grid>
              <Grid item sm={3} xs={6} style={{ marginLeft: "-3%" }}>
                <BooleanInput
                // style={{marginLeft:"3px"}}
                  label={<span style={{paddingLeft:"0px"}}>Many Attendees</span>}
                  source="manyAttendees"
                />
              </Grid>
              {/* <Grid item sm={5} xs={1}>
                <Typography varint="body2" style={{ textAlign: "left", marginTop: "5px", marginLeft: "-4%" }}>Many Attendes</Typography>

              </Grid> */}
            </Grid>
            {values.manyAttendees ?
              <Grid container style={{ marginTop: "26px", marginLeft: "-3.5%", }}>
                <Grid item sm={4} xs={2} ></Grid>
                <Grid item sm={5} xs={10}>
                  <Typography variant="subtitle2" style={{ fontSize: "23px", textAlign: "left", marginLeft: "-12%" }}>Select Attendes</Typography>

                  <div style={{ marginTop: "10px", marginLeft: "-12%" }}>
                    <Asynchronous form={form} />
                  </div>
 
                </Grid>
                {/* <Grid style={{marginLeft:"910px"}}>
                            <Typography style={{color:"red",fontSize:'12px'}} >*Maximum 10 Attendes</Typography>
                            </Grid> */}
              </Grid> :
              null}
            <Grid container style={{ marginTop: "5vh" }}>
              <Grid item xs={6}>
                <Button
                  style={{ background: "#D14002", color: "white", borderRadius: "5px", padding: "5px  ", width: "100px" }}
                  onClick={() => { }}>

                  Cancel
                    </Button>
              </Grid>
              <Grid item xs={6} >
                <Button
                  type="submit"
                  style={{ background: "#0288D1", color: "white", borderRadius: "5px", float: "right", padding: "5px  ", width: "90px" }}
                // onClick={handleClick}
                >
                  Next
                </Button>
              </Grid>

            </Grid>
          </Paper>

        </div>
      </form>
    </div>
  );
}
